var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPromotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    stroke: "#ececec",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4017 2.88137L8.53136 7.13936C7.84868 7.46706 7.11924 7.54915 6.37566 7.38257C5.88902 7.27356 5.64568 7.21905 5.44974 7.19667C3.01657 6.91882 1.5 8.84456 1.5 11.059V12.2743C1.5 14.4888 3.01657 16.4145 5.44974 16.1367C5.64568 16.1143 5.88904 16.0598 6.37566 15.9508C7.11924 15.7842 7.84868 15.8663 8.53136 16.194L17.4017 20.452C19.4379 21.4294 20.456 21.9181 21.5912 21.5372C22.7263 21.1563 23.1159 20.3389 23.8952 18.7041C26.0349 14.2149 26.0349 9.11846 23.8952 4.62928C23.1159 2.99448 22.7263 2.17707 21.5912 1.79613C20.456 1.41519 19.4379 1.90392 17.4017 2.88137Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8333 19.6667V20.3333C14.8333 22.0454 14.8333 22.9015 14.5346 23.3848C14.1363 24.0292 13.4081 24.3933 12.6536 24.3253C12.0878 24.2742 11.4029 23.7606 10.0333 22.7333L8.43325 21.5333C7.12996 20.5559 6.83325 19.9624 6.83325 18.3333V16.3333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.6667V7.66667",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPromotion);
export default __webpack_public_path__ + "static/media/icon-promotion.45089693ba51da74de6028166e04426c.svg";
export { ForwardRef as ReactComponent };